import Axios from 'axios';
import {uiConst} from './../app/config/Constant';
import {getToken} from './TokenManager';
import base64 from 'base-64';

function getAuthToken() {
    return 'Token ' + getToken();
}

const axiosInstance = Axios.create({
    baseURL: uiConst.getUrl(),
    headers: {
        'Content-Type': 'application/json',
        'Pragma': 'no-cache'
    }
});

const axiosInstanceWithToken = Axios.create({
    baseURL: uiConst.getUrl(),
    headers: {
        'Content-Type': 'application/json',
        'Pragma': 'no-cache'
    }
});

axiosInstanceWithToken.interceptors.request.use(config => {
    config.headers.Authorization = getAuthToken()
    return config;
},(error) => {
    return Promise.reject (error);
});

const convertJsonBase64 = (data) => base64.encode(JSON.stringify(data));

export {
    axiosInstance,
    axiosInstanceWithToken,
    getAuthToken,
    convertJsonBase64
};



// WEBPACK FOOTER //
// ./src/utils/Client.js